import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';

//MaterialUI Imports
import {
    Alert,
    Autocomplete,
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Snackbar,
    Stack,
    TextField,
    Tooltip,
    Typography,
    CardHeader,
    InputLabel,
    Card,
    CardContent,
    CircularProgress,
    Select,
    MenuItem
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import MainCard from 'ui-component/cards/MainCard';

//icons
import AssessmentIcon from '@mui/icons-material/Assessment';
import EditIcon from '@mui/icons-material/Edit';
import ArticleIcon from '@mui/icons-material/Article';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

//project imports
import { locations, roles } from 'store/constant';
import NoResults from 'assets/images/noresults.png';
import useSalariesService from 'services/useSalariesService';
import useEmployeeService from 'services/useEmployeeService';
import useReportService from 'services/useReportService';

const RevenueReport = () => {
    //Constants
    const theme = useTheme();
    const navigate = useNavigate();
    const { getRevenueTotalReport } = useReportService();
    const { getEmployees } = useEmployeeService();
    //const { month, year } = props;
    const pageSize = 50;

    //States
    const [employeeRevenueDetails, setEmployeeRevenueDetails] = useState([]);
    //const date = new Date();
    const [selectedRole, setSelectedRole] = useState(0);
    const [selectedLocation, setSelectedLocation] = useState(-1);
    const [selectedFromDate, setSelectedFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [selectedToDate, setSelectedToDate] = useState(new Date().toISOString().split('T')[0]);

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openToast, setOpenToast] = useState(false);
    const [selectedEmployeeSalaryRecord, setSelectedEmployeeSalaryRecord] = useState();

    const [isError, setIsError] = useState();

    //Methods

    const handleCloseToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenToast(false);
    };

    const getEmployeeRevenueList = () => {
        //setEmployeeSalaryDetails(undefined);
        getRevenueTotalReport(selectedRole, selectedLocation, selectedFromDate, selectedToDate)
            .then((response) => {
                console.log(response);
                //setEmployeeCount(response.data.count);
                // console.log('DRRRR', response.data, selectedRole, selectedMonth, selectedYear);
                setEmployeeRevenueDetails(response.data);
            })
            .catch((error) => setIsError(error.message));
    };

    // const handleDelete = () => {
    //     deleteSalaries(selectedEmployeeSalaryRecord.id)
    //         .then((response) => {
    //             getEmployeeList();
    //             setOpenToast(true);
    //             setOpenDeleteDialog(false);
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //             setOpenDeleteDialog(false);
    //         });
    // };

    // const handleChange = (e) => {
    //     setSelectedLocation(e.target.value);
    // };

    //useEffects
    useEffect(() => {
        getEmployeeRevenueList();
    }, [selectedRole, selectedLocation, selectedFromDate, selectedToDate]);

    return (
        <>
            <MainCard>
                <CardHeader
                    avatar={<AssessmentIcon color="primary" />}
                    title="Revenue Report"
                    sx={{ padding: 0 }}
                    action={
                        <Button
                            variant="outlined"
                            onClick={() => {
                                navigate('/sales');
                            }}
                            sx={{ marginRight: 1 }}
                            startIcon={<ArrowBackIcon />}
                        >
                            Back
                        </Button>
                    }
                />
                <Divider sx={{ marginY: 3 }} />
                <Typography variant="h4">Select parameters to view revenue report</Typography>
                <Grid container direction="row" spacing={2} ustifyContent="space-between" alignItems="center" sx={{ marginY: 0.5 }}>
                    {/* <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ marginY: 2 }}>
                        <Stack direction="row" spacing={2}> */}
                    <Grid item sm={4.5} xs={12}>
                        {/* <Stack direction="row" spacing={2}> */}
                        <Select
                            labelId="role-select-label"
                            id="role-select"
                            name="role"
                            size="small"
                            fullWidth
                            //sx={{ width: 280 }}
                            value={selectedRole}
                            onChange={(e) => {
                                setSelectedRole(e.target.value);
                            }}
                        >
                            {/* <MenuItem key={-1} value={-1}>
                                Select Role
                            </MenuItem> */}
                            {roles?.map((role, index) => {
                                return (
                                    <MenuItem key={index} value={index}>
                                        <Typography>{role}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                        {/* </Stack> */}
                    </Grid>
                    <Grid item sm={2.5} xs={12}>
                        {/* <Stack direction="row" spacing={2}> */}
                        <Select
                            labelId="location-select-label"
                            id="location-select"
                            name="location"
                            size="small"
                            fullWidth
                            //sx={{ width: 150 }}
                            value={selectedLocation}
                            onChange={(e) => {
                                setSelectedLocation(e.target.value);
                            }}
                        >
                            <MenuItem key={-1} value={-1}>
                                Select
                            </MenuItem>
                            {locations?.map((location, index) => {
                                return (
                                    <MenuItem key={index} value={index}>
                                        <Typography>{location}</Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                        {/* </Stack> */}
                    </Grid>
                    <Grid item sm={2.5} xs={12}>
                        <TextField
                            type="date"
                            label="From"
                            size="small"
                            fullWidth
                            //sx={{ width: 150 }}
                            value={selectedFromDate}
                            onChange={(e) => {
                                setSelectedFromDate(e.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item sm={2.5} xs={12}>
                        <TextField
                            label="To"
                            size="small"
                            type="date"
                            fullWidth
                            //sx={{ width: 150 }}
                            value={selectedToDate}
                            onChange={(e) => {
                                setSelectedToDate(e.target.value);
                            }}
                        />
                    </Grid>
                    {/* </Stack>
                    </Stack> */}
                </Grid>
                <Divider sx={{ marginY: 3 }} />
                {employeeRevenueDetails != undefined || employeeRevenueDetails != null ? (
                    <>
                        <Grid container direction="row" spacing={2}>
                            <Grid item sm={3} xs={12} align="left">
                                <Card variant="outlined" sx={{ backgroundColor: theme.palette.orange.light, borderRadius: 2, padding: 2 }}>
                                    <Stack direction="column" spacing={1}>
                                        <Typography variant="h5" sx={{ color: theme.palette.grey[700] }}>
                                            Total Units Sold:
                                        </Typography>
                                        <Typography display="inline" variant="h3">
                                            {employeeRevenueDetails.totalSaleUnit}
                                        </Typography>
                                    </Stack>
                                </Card>
                            </Grid>

                            <Grid item sm={3} xs={12} align="left">
                                <Card variant="outlined" sx={{ backgroundColor: theme.palette.success.light, borderRadius: 2, padding: 2 }}>
                                    <Stack direction="column" spacing={1}>
                                        <Typography variant="h5" sx={{ color: theme.palette.grey[700] }}>
                                            Total Sales Amount:
                                        </Typography>
                                        <Typography display="inline" variant="h3">
                                            ₹ {employeeRevenueDetails.totalAmount}
                                        </Typography>
                                    </Stack>
                                </Card>
                            </Grid>
                        </Grid>
                    </>
                ) : null}

                <Divider sx={{ marginY: 3 }} />
                {employeeRevenueDetails != undefined || employeeRevenueDetails != null ? (
                    <>
                        {employeeRevenueDetails.length === 0 ? (
                            <Grid align="center" sx={{ mt: 5, mb: 5 }}>
                                <img src={NoResults} alt="No Result" width="150px" />
                                <Typography variant="h4" fontWeight={100}>
                                    There are no employee revenue record found
                                </Typography>
                            </Grid>
                        ) : (
                            <>
                                <Grid item sm={12} md={12} lg={12} sx={{ display: { xs: 'none', sm: 'block', md: 'block', xl: 'block' } }}>
                                    <TableContainer>
                                        <Table
                                            sx={{
                                                border: 'solid',
                                                borderWidth: 1,
                                                borderColor: 'divider'
                                            }}
                                        >
                                            <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
                                                <TableCell sx={{ width: 70 }}>
                                                    <Typography variant="h5">Sr.No.</Typography>{' '}
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="h5">Employee Name</Typography>{' '}
                                                </TableCell>
                                                <TableCell sx={{ width: 150 }}>
                                                    <Typography variant="h5">Employee Role</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 120 }}>
                                                    <Typography variant="h5">Unit Sold</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 120 }}>
                                                    <Typography variant="h5">Sale Amount</Typography>
                                                </TableCell>
                                                {/* <TableCell sx={{ width: 190 }}>
                                                <Typography variant="h5">Recorded By</Typography>
                                            </TableCell> */}

                                                <TableCell sx={{ width: 120 }}></TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {employeeRevenueDetails.revenueReports?.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell align="left">{row.userName}</TableCell>
                                                        <TableCell align="left">{row.roleDisplay}</TableCell>
                                                        <TableCell align="left">{row.totalSaleUnit}</TableCell>
                                                        <TableCell align="left">{row.totalAmount}</TableCell>
                                                        <TableCell align="right">
                                                            <Tooltip title="Sales details">
                                                                <IconButton
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        const state = {
                                                                            userId: row.userId,
                                                                            fromDate: selectedFromDate,
                                                                            toDate: selectedToDate
                                                                        };
                                                                        navigate('/revenuereportdetails', { state });
                                                                    }}
                                                                >
                                                                    <ArticleIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            {/*<Tooltip title="Edit Sales Record details">
                                                            <IconButton
                                                                variant="outlined"
                                                                color="primary"
                                                                size="small"
                                                                onClick={() => {
                                                                    setSelectedSalesRecord(row);
                                                                    setOpenForm(true);
                                                                }}
                                                            >
                                                                <EditIcon fontSize="inherit" />
                                                            </IconButton>
                                                        </Tooltip> */}
                                                            <Tooltip title="Delete employee salary record">
                                                                <IconButton
                                                                    color="error"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedEmployeeSalaryRecord(row);
                                                                        setOpenDeleteDialog(true);
                                                                    }}
                                                                >
                                                                    <DeleteIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                {employeeRevenueDetails.revenueReports?.map((row, index) => (
                                    <Grid key={index} item xs={12} sx={{ display: { xs: 'block', sm: 'none', md: 'none', xl: 'none' } }}>
                                        <Card sx={{ p: 2 }} variant="outlined" key={index}>
                                            <Stack justifyContent="space-between" direction="row" alignItems="center" spacing={2}>
                                                <Typography variant="h5">Employee Name:</Typography>
                                                <Typography>{row.userName}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Employee Role:</Typography>
                                                <Typography> {row.roleDisplay}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Employee Sale Unit:</Typography>
                                                <Typography>{row.totalSaleUnit}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Total Amount:</Typography>
                                                <Typography>{row.totalAmount}</Typography>
                                            </Stack>

                                            <Divider sx={{ mt: 1 }} />
                                            <Stack justifyContent="flex-end" direction="row" alignItems="right" sx={{ mt: 2 }}>
                                                <Tooltip title="Sales details">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => {
                                                            const state = {
                                                                userId: row.userId,
                                                                fromDate: selectedFromDate,
                                                                toDate: selectedToDate
                                                            };
                                                            navigate('/revenuereportdetails', { state });
                                                        }}
                                                    >
                                                        <ArticleIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                                {/*<Tooltip title="Edit Sales Record details">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        onClick={() => {
                                                            setSelectedSalesRecord(row);
                                                            setOpenForm(true);
                                                        }}
                                                    >
                                                        <EditIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>{' '}
                                                */}
                                                <Tooltip title="Delete employee salary record">
                                                    <IconButton
                                                        color="error"
                                                        size="small"
                                                        onClick={() => {
                                                            setSelectedEmployeeSalaryRecord(row);
                                                            setOpenDeleteDialog(true);
                                                        }}
                                                    >
                                                        <DeleteIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Stack>
                                        </Card>
                                    </Grid>
                                ))}
                            </>
                        )}
                    </>
                ) : (
                    <Stack direction="column" justifyContent="Center" alignItems="center" spacing={2} sx={{ marginY: 3 }}>
                        <Typography variant="h4" textAlign="center">
                            Getting Employee Revenue List...
                        </Typography>
                        <CircularProgress />
                    </Stack>
                )}
            </MainCard>

            <Dialog
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                }}
                fullWidth
            >
                <DialogTitle>
                    <Typography variant="h4" color={theme.palette.secondary.dark}>
                        Delete salary Details
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h5" color={theme.palette.error}>
                        Are you sure you want to delete this salary details ?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <LoadingButton
                        onClick={() => {
                            handleDelete();
                        }}
                        variant="contained"
                    >
                        Yes
                    </LoadingButton>
                    <LoadingButton
                        onClick={() => {
                            setOpenDeleteDialog(false);
                        }}
                        variant="outlined"
                    >
                        No
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            <Grid item xs={12} sm={12} md={12} lg={12} align="center">
                <Snackbar open={openToast} autoHideDuration={6000} onClose={handleCloseToast}>
                    <Alert
                        onClose={handleCloseToast}
                        severity="success"
                        sx={{ width: '100%', backgroundColor: theme.palette.success.main }}
                    >
                        <Typography sx={{ color: theme.palette.grey[50] }}> Salary deleted succesfully!!</Typography>
                    </Alert>
                </Snackbar>
            </Grid>
        </>
    );
};

export default RevenueReport;
